// http://192.168.0.74:9999// http://zht-api.test.2vm.co/
export default {
  baseUrl: {
    pro: 'https://zht-api.windc.vip/',
    dev: 'http://zht-api.test.2vm.co/',
    uat:'http://zht_api.uat.2vm.co/'
  },
  oss: {
    dev: 'https://ydd-oss.2v2.co/',
    pro: 'https://zy-oss.windc.vip/',
    uat:'https://ydd-oss.2v2.co/'
  }
}

